<template>
  <!-- 设备中心 start -->
   <div class="product-menu device-menu" v-show="showDeviceMenu">
     <div class="product-m-left">
       <span class="device-menu-btn" v-show="false">查看详情</span>
     </div>
     <div class="product-m-right">
         <div class="pro-m-flex" v-for="(item,index) in deviceList" :key="index+'_1'">
           <div class="product-title">{{item.productCategoryName}}</div>
           <ul>
             <li v-for="(info,index) in item.childList" :key="index+'_2'" @click="goProduct(info)">{{info.productCategoryName}}</li>
           </ul>
         </div>
     </div>
   </div>
   <!-- 设备中心 end -->
</template>

<script>
import { IsPC } from "@/utils"
export default {
  props: [],
  data(){
    return{
      showDeviceMenu: true
    }
  },
  computed:{
    deviceList (){
      let list = this.$store.getters.deviceList
      let newList = list.slice(0, 4)
      // console.log(list,newList);
      
      return newList || []
    }
  },
  methods: {
    IsPC,
    handleOpen(){
      this.showDeviceMenu = true
    },
    handleClose(){
      this.showDeviceMenu = false
    },
    goProduct(item){
      this.$emit('closeMenu', 3)
      setTimeout(() => {
        this.$store.dispatch('setDeviceClassId', item.productCategoryCode)
        this.$router.push({path:'/device'})
      }, 200);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/menu.scss';
</style>


// WEBPACK FOOTER //
// src/views/components/menu-device.vue